import { BestPerformingExposure } from '../../../../../../models/influencer';
import { Router } from '@angular/router';
import { platformIconPathById } from '../../../../../app.constants';
import { DateUtils } from '../../../../../utils/date.utils';
import { UserService } from '../../../../../services/user.service';
import { PdfExportService } from '../../../../../services/export-pdf/pdf-export.service';
import { BestPerformingPostsComponent } from '../best-performing-posts.component';
var BestPerformingPostItemComponent = /** @class */ (function () {
    function BestPerformingPostItemComponent(pdfService, userService, router) {
        this.pdfService = pdfService;
        this.userService = userService;
        this.router = router;
        this.post = new BestPerformingExposure();
    }
    BestPerformingPostItemComponent.prototype.getPlatformIcon = function (platformId) {
        if (!platformId) {
            return '';
        }
        return platformIconPathById[platformId].path;
    };
    BestPerformingPostItemComponent.prototype.onLoadedImage = function () {
        this.pdfService.updateNumberImageLoaded(BestPerformingPostsComponent.COMPONENT_NAME);
    };
    BestPerformingPostItemComponent.prototype.onLoadedImageError = function () {
        this.pdfService.updateNumberImageLoaded(BestPerformingPostsComponent.COMPONENT_NAME);
    };
    Object.defineProperty(BestPerformingPostItemComponent.prototype, "activeAccount", {
        get: function () {
            return this.userService.getCompanyId();
        },
        enumerable: true,
        configurable: true
    });
    BestPerformingPostItemComponent.prototype.formatPublishDate = function (publishDate) {
        return DateUtils.formatDate(publishDate);
    };
    BestPerformingPostItemComponent.prototype.openPostPage = function () {
        var currentInfluencer = this.userService.getInfluencerInfo();
        // influencer platform version
        if (currentInfluencer) {
            return this.router.navigate(['dashboard', 'post', this.post.urlHash]);
        }
        else {
            return this.router.navigate(['post'], { queryParams: {
                    influencerId: this.post.influencer_id,
                    urlHash: this.post.urlHash,
                    fullUrl: this.post.url,
                    relativePath: this.post.relativepath,
                    activeAccount: this.activeAccount
                } });
        }
    };
    return BestPerformingPostItemComponent;
}());
export { BestPerformingPostItemComponent };



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-post-item/best-performing-post-item.component.ts.pre-build-optimizer.js